import { Reveal } from "@/components/Reveal";
import { CtaPair } from "@/components/CtaButtons";

const FEATURES = [
  {
    title: "ER Capability Diagnostic",
    desc: "An assessment of your organisation's current Employee Relations capability — processes, governance, roles, escalation, case management and risk gaps.",
    to: "/er-capability-diagnostic",
    reason: "ER Framework / Capability",
    key: "diagnostic",
  },
  {
    title: "Scalable ER Function Build",
    desc: "Design or strengthening of your ER operating model — frameworks, governance, investigation processes, escalation, roles, case-management principles and manager capability.",
    to: "/employee-relations-framework",
    reason: "ER Framework / Capability",
    key: "framework",
  },
  {
    title: "Fractional ER & People-Risk Partner",
    desc: "Ongoing senior Employee Relations and People Risk support for organisations that need experienced capability without hiring a full-time Head of ER.",
    to: "/fractional-er-partner",
    reason: "Fractional ER Support",
    key: "fractional",
  },
];

export function CapabilityJourney() {
  return (
    <section id="capability" data-testid="capability-journey-section" className="py-28 px-6 md:px-12 bg-surface border-t border-white/10">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Build ER capability</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tight max-w-3xl mb-6">
            Move from reactive case handling to a scalable ER model.
          </h2>
          <p className="text-muted2 max-w-2xl leading-relaxed mb-16">
            Growing organisations often manage employee issues reactively — until scale, complexity or geographic
            expansion creates inconsistent decisions and unnecessary people risk. These engagements build the capability
            to handle ER consistently and defensibly.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <Reveal key={f.key} delay={i * 0.06}>
              <div data-testid={`capability-feature-${f.key}`} className="border border-white/12 hover:border-gold/40 transition-colors duration-300 p-8 h-full flex flex-col bg-ink/40">
                <h3 className="font-serif text-2xl font-light mb-4">{f.title}</h3>
                <p className="text-muted2 text-sm leading-relaxed flex-1 mb-8">{f.desc}</p>
                <CtaPair serviceTo={f.to} serviceLabel="Explore" reason={f.reason}
                  serviceTestid={`capability-explore-${f.key}`} bookTestid={`capability-book-${f.key}`} />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
